<template>
	<div>
		<nav ref="cntFolhas" class="cnt-folhas tam_a4">
			<div class="folha" contenteditable></div>
			<div class="folha" contenteditable></div>
		</nav>
	</div>
</template>
<script>
	export default {
		name: '',
		data() {
			return {};
		},
		methods: {},
		computed: {},
		mounted() {
			$(this.$refs.cntFolhas).keyup((e) => {
				if (e.keyCode == 32) {
					console.log(e);
				}
			});
			this.$emit('setHeader', ['Criar Template', '']);
		},
	};
</script>
<style scoped>
	.tam_a4 > .folha {
		width: 210mm;
		height: 296mm;
	}
	.tam_carta > .folha {
		width: 216mm;
		height: 278mm;
	}
	.tam_oficio > .folha {
		width: 216mm;
		height: 354mm;
	}
	.folha {
		background: #fff;
		margin: 0 auto 1.5cm;
		padding: 13mm 10mm;
		position: relative;
		overflow: hidden;
		border-radius: 3px;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
		box-sizing: border-box;
	}
</style>



// WEBPACK FOOTER //
// src/components/models/template/index.vue